import styled from '@emotion/styled'

import { Flex } from '../Flex'

import { colors } from '@/constants/colors'

export const SubSidebarItem = styled(Flex)<{ isActive?: boolean }>`
  gap: 0.625rem;
  height: 54px;
  padding: 15px;
  align-items: center;
  border-radius: 1rem;
  transition: background-color 0.3s ease-in-out;
  color: white;
  cursor: pointer;

  &:hover {
    background-color: ${colors.darkBlue3};
  }
  &:active {
    background-color: ${colors.darkBlue4};
  }

  ${({ isActive }) => isActive && `background-color: ${colors.darkBlue2};`}
`
